import { render, staticRenderFns } from "./detailsCase.vue?vue&type=template&id=03b8ab38"
import script from "./detailsCase.vue?vue&type=script&lang=js"
export * from "./detailsCase.vue?vue&type=script&lang=js"
import style0 from "./detailsCase.vue?vue&type=style&index=0&id=03b8ab38&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports